<template>
  <v-app

  >
    <v-layout
      align-center
      justify-center
      row
      fill-height
      v-if="hidecontent === '1'"
    >
      <div class="text-xs-center">
        <v-progress-circular indeterminate class="primary--text" :size="100" :width="3"></v-progress-circular>
        <br>loading...
      </div>
    </v-layout>
    
    <v-layout
      v-else
      row
      wrap
    >
      <v-flex 
        xs12
        sm12
        md6
        :style="$vuetify.breakpoint.mdAndUp ? 'padding-top: 0px' : 'padding-top: 40px'"
      >
        <div
          v-if="!$store.state.logged"
          :class="{'login' : $vuetify.breakpoint.smAndUp}"
          class="centerLogin"
        >
          <v-layout 
            row
            justify-space-between
          >
            <v-flex md2 />
            <v-flex
              :class="{
                'md6': domaine.indexOf('targetfirst') === -1 && domaine.indexOf('localhost') === -1,
                'lg4': domaine.indexOf('targetfirst') === -1 && domaine.indexOf('localhost') === -1,
                'sm8': domaine.indexOf('targetfirst') !== -1 || domaine.indexOf('localhost') !== -1,
              }"
              xs12
              style="min-width:80%;"
            >

              <div
                v-if="loadingRegister"
                class="text-xs-center"
              >
                <v-progress-circular
                  :size="70"
                  :width="1"
                  indeterminate
                  class="primary--text"
                />
              </div>

              <v-card
                v-else-if="!registering"
                flat
                style="border-radius: 8px; padding-top: 50px;"
              >
                <v-card-title>
                  <v-toolbar card prominent color="white">
                    <v-toolbar-title class="body-2">
                      <img
                        :src="domaine.indexOf('targetfirst') !== -1 || domaine.indexOf('localhost') !== -1
                          ? `${domaine}/static/logoAccueil.svg`
                          : `${domaine}/static/logoAccueil.svg`"
                        style="max-width:100%; max-height:200px; width:auto; height:auto;"
                      />
                    </v-toolbar-title>

                    <v-spacer />

                    <v-btn icon>
                      <img
                        :src="`${domaine}/static/flag_fr.svg`"
                        style="max-width:100%; width:auto; height:auto;"
                        @click="updateLang('fr')"
                      />
                    </v-btn>

                    <v-btn icon>
                      <img
                        :src="`${domaine}/static/flag_uk.svg`"
                        style="max-width:100%; width:auto; height:auto;"
                        @click="updateLang('en')"
                      />
                    </v-btn>

                    <v-btn icon>
                      <img
                        :src="`${domaine}/static/flag_es.svg`"
                        style="max-width:100%; width:auto; height:auto;"
                        @click="updateLang('es')"
                      />
                    </v-btn>
                  </v-toolbar>

                </v-card-title>

                <v-card-text>
                  <v-container>
                    <form autocomplete="on">
                      <v-text-field 
                        v-model="email"
                        box
                        :label="$t('email') | cap"
                        type="email"
                        data-vv-name="email"
                        required
                        v-validate="'required|email'"
                        :error="wzErrors.has('email')"
                        :error-messages="wzErrors.collect('email')"
                        @keyup.enter="login"
                        autofocus
                      />
                      <v-text-field 
                        v-model="password"
                        box
                        :label="$t('password') | cap" 
                        type="password" 
                        data-vv-name="password"
                        required 
                        v-validate="'required'"
                        :error="wzErrors.has('password')"
                        :error-messages="wzErrors.collect('password')"
                        @keyup.enter="login"
                      />
                    </form>
                    <v-checkbox
                      :label="$t('reconnexion')|cap"
                      v-model="rememberPwd"
                      :disabled="loadingLogin"
                    />
                    <v-btn 
                      block
                      color="btn" 
                      class="white--text"
                      style="border-radius: 8px;"
                      :loading="loadingLogin" 
                      :disabled="wzErrors.any() " 
                      @click="login(false)"
                    >
                      {{ $t('login') }}
                      <v-icon
                        right
                        dark
                        style="rotate: -90deg;"
                      >
                        arrow_circle_down
                      </v-icon>

                    </v-btn>
                    <!-- a mettre plus tard
                    <v-checkbox
                      :label="$t('connectingOnline')"
                      v-model="settingsConnectStatusCookies"
                      color="primary"
                      :disabled="loadingLogin"
                    >
                    </v-checkbox>
                  -->

<!--
					<div id="bloc_page">
					  <center>
					  	<div id="g_id_onload"
					  	  data-client_id="980029255463-8f8h8eufas2usugbu24ta3uugqkginge.apps.googleusercontent.com"
					  	  data-login_uri="https://public.targetfirst.com/public/google/checklogin.php"
					  	  data-auto_prompt="false">
					  	</div>
					  	<div class="g_id_signin"
					  	  data-type="standard"
					  	  data-size="large"
					  	  data-theme="outline"
					  	  data-text="sign_in_with"
					  	  data-shape="rectangular"
					  	  data-logo_alignment="left">
					  	</div>	
					  	<p><span id="googlename"></span></p>
					  </center>
					</div>
					<div id="bloc_page">
					  <center>
              <a class="connectLinkedin" href="https://public.targetfirst.com/public/linkedin/checktoken.php">
                <div class="loginButton">
                  <img src="https://www.targetfirst.com/media/logonlinkedin.png" width="20px">
                  <span class="connectwith">{{$t('connectLinkedin')}}</span>
                </div>
              </a>
					  </center>
					</div>
-->

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-btn
                          :disabled="loadingLogin"
                          flat
                          block
                          :href="`${domaine}/login/retrievepassword_` + $i18n.locale + `.php`"
                        >
                          {{ $t('passwordForgotten') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>

              <v-card
                v-else
                :flat="$vuetify.breakpoint.xsOnly"
              >
                <v-card-title primary-title class="primary">
                  <v-layout row justify-space-between>
                    <v-flex lg2></v-flex>
                    <img :src="`${domaine}/static/logo_tf.svg`" style="max-width:100%;max-height:200px;width:auto;height:auto;">
                    <v-flex lg2></v-flex>
                  </v-layout>
                </v-card-title>
                <v-container>
                  <v-card-text>
                    <form autocomplete="on">
                      <v-text-field 
                        v-model="url" 
                        prepend-icon="http" 
                        label="URL de votre site"
                        data-vv-name="url"
                        required 
                        v-validate="'required|url:require_protocol'"
                        :error="wzErrors.has('url')"
                        :error-messages="wzErrors.collect('url')"
                      ></v-text-field>
                      <v-text-field 
                        v-model="email" 
                        prepend-icon="mail" 
                        label="Mail de contact" 
                        readonly
                        required
                      ></v-text-field>
                      <v-text-field 
                        v-model="password" 
                        :label="$t('password')" 
                        type="password" 
                        data-vv-name="password"
                        required 
                        v-validate="'required|min:12'"
                        :error="wzErrors.has('password')"
                        :error-messages="wzErrors.collect('password')"
                        prepend-icon="lock"
                        loading
                      >
                        <v-progress-linear slot="progress" :value="progress" height="5" :color="color"></v-progress-linear>
                      </v-text-field>
                      <v-text-field 
                        v-model="confirmPassword" 
                        label="Confirmez votre mot de passe" 
                        type="password" 
                        :rules="[rules.confirmPassword]"
                        data-vv-name="confirmPassword"
                        required 
                        v-validate="'required'"
                        :error="wzErrors.has('confirmPassword')"
                        :error-messages="wzErrors.collect('confirmPassword')"
                        prepend-icon="lock"
                      ></v-text-field>
                      <v-text-field 
                        v-model="firstName"
                        prepend-icon="accessibility"
                        label="Votre prénom"
                        data-vv-name="firstName"
                        required 
                        v-validate="'required'"
                        :error="wzErrors.has('firstName')"
                        :error-messages="wzErrors.collect('firstName')"
                      ></v-text-field>
                      <v-text-field 
                        v-model="lastName" 
                        prepend-icon="accessibility"
                        label="Votre nom"
                      ></v-text-field>
                      <v-text-field 
                        v-model="phone"
                        prepend-icon="phone"
                        label="Votre téléphone"
                      ></v-text-field>
                    </form>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      block
                      color="secondary" 
                      class="white--text" 
                      :loading="loadingLogin" 
                      :disabled="wzErrors.any() || confirmPassword != password" 
                      @click="register()"
                    >
                      S'inscrire !
                      <v-icon right dark>send</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex md2></v-flex>
          </v-layout>
          <v-layout/>
        </div>
      </v-flex>

      <v-flex
        xs12
        sm12
        md6
        :style="$vuetify.breakpoint.mdAndUp ? 'height:100%;' : 'height:80%;'"
      >

          <iframe
            src="https://backoffice.targetfirst.com/login/news/news2.html"
            width="100%"
            height="100%"
            :class="$vuetify.breakpoint.xs ? 'pasMarge' : 'Marge'"
          ></iframe>

      </v-flex>
    </v-layout>
  
    <!-- DIALOG ERREUR SSO -->
    <v-dialog v-model="dialogSSO" scrollable persistent max-width="500">
      <v-card>
        <v-card-title class="title primary white--text">Connexion échouée</v-card-title>
        <v-card-text>
          <p>Ce compte n'est pas reconnu par Target First.</p>
          <p>Contactez votre responsable de compte pour qu'il vous y ajoute<br>ou<br>contactez le support Target First support@targetfirst.com</p>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            block
            color="secondary" 
            class="white--text" 
            @click="dialogSSO = false"
          > Fermer </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  

    <!-- DIALOG SCRIPT -->
    <v-dialog v-model="dialog" scrollable persistent max-width="400">
      <v-card>
        <v-card-title class="title primary white--text">{{ $t('congratulations') }}</v-card-title>
        <v-card-text>
          <span>{{ $t('registrationOk') }}</span>
          <v-textarea
            outline
            label="Votre script Target First"
            class="code-HTML"
            readonly
            :value="'<script type=\'text/javascript\' src=\'//public.targetfirst.com/deliver/targetfirst.js?wzkey=' + wzkey + '\'></script>'"
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            block
            color="secondary" 
            class="white--text" 
            :loading="loadingLogin" 
            :disabled="wzErrors.any() " 
            @click="login(false)"
          > {{ $t('login') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG STATUS DECONNEXION -->
    <v-dialog v-model="dialogDeconnexion" scrollable persistent  max-width="290">
      <v-card v-if="$store.state.reasonDeco">
        <v-card-title class=" primary white--text">{{ $t($store.state.reasonDeco.title) }}</v-card-title>
        <v-card-text>
          <div v-html="$t($store.state.reasonDeco.content)"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            block
            color="primary" 
            flat
            @click="closeDialogDeco()"
          >ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar v-model="snack.show" left>
      {{ snack.msg }}
      <v-btn flat :class="snack.context + '--text'" @click="snack.show = false">
        {{ snack.btn }}
        <span>
          <v-icon right v-if="snack.context == 'success'">check_circle</v-icon>
          <v-icon right v-else-if="snack.context == 'info'">info</v-icon>
          <v-icon right v-else-if="snack.context == 'warning'">warning</v-icon>
          <v-icon right v-else-if="snack.context == 'error'">error</v-icon>
        </span>
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import _ from 'lodash'
import { DOMAINE } from '../constants'
import { mapMutations } from 'vuex'
/* import Vue from 'vue'
import VueGtm from 'vue-gtm'
Vue.use(VueGtm, {
}) */
export default {
  name: 'Login',
  data () {
    return {
      elements: ['ElementA', 'ElementB', 'ElementC', 'ElementD'],
      randomElement: null,
      /**
       - Indique le domaine de l'appli
       - @type {String}
       */
      domaine: DOMAINE,
      connexionType: 'targetfirst',
      /**
       * L'utilisateur géré lors de la connexion
       * @type {Object}
       */
      user: {
        /**
         * Indique si suite à la connexion
         * l'agent se trouve 'en ligne'
         * @type {Boolean}
         */
        // connectingOnline: true
      },
      /**
       * Indique si l'utilisateur tente de se connecter
       * @type {Boolean}
       */
      loadingLogin: false,
      /**
       * Indique si tentative de création de compte
       * @type {Boolean}
       */
      loadingRegister: false,
      /**
       * Affiche une dialog info deconnexion
       * @type {Boolean}
       */
      dialogDeconnexion: false,
      /**
       * Indique si la page est en mode registering
       * (création de compte)
       * @type {Boolean}
       */
      settingsConnectStatusCookies: true,
      rememberPwd: false,
      registering: false,
      email: '',
      password: '',
      sso: '0',
      welcome: '',
      hidecontent: '0',
      token: '',
      /**
       * En cas de création de licence
       */
      url: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
      rules: {
        confirmPassword: (v) => this.confirmPassword === this.password || this.$t('pwdsNotMatch')
      },
      /**
       * Indique si le dialog est affichée
       * @type {Boolean}
       */
      dialog: false,
      /**
       * Indique si le dialogSSO est affichée
       * @type {Boolean}
       */
      dialogSSO: false,
      wzkey: '',
      /**
       * Snackbar
       * @type {Object}
       */
      snack: {
        show: false,
        msg: '',
        context: 'info',
        btn: this.$t('close')
      }
    }
  },

  components: {
    ElementA: {
      template: '<iframe src="https://cloud.targetfirst.com/login/accueil1.html" width="100%" height="100%"></iframe>'
    },
    ElementB: {
      template: '<iframe src="https://cloud.targetfirst.com/login/accueil2.html" width="100%" height="100%"></iframe>'
    },
    ElementC: {
      template: '<iframe src="https://cloud.targetfirst.com/login/accueil3.html" width="100%" height="100%"></iframe>'
    },
    ElementD: {
      template: '<iframe src="https://cloud.targetfirst.com/login/accueil4.html" width="100%" height="100%"></iframe>'
    }
  },
  computed: {
    progress () {
      return Math.min(100, this.password.length * 10)
    },
    color () {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
    }
  },

  created () {
    // console.log('start login')
    // ----------------------------------------------------------------------------
    // Pour FRESHDESK uniquement
    // ----------------------------------------------------------------------------
    // Tests afin de savoir s'il s'agit d'une connexion depuis freshdesk
    if (DOMAINE.indexOf('freshdesk') !== -1 || (this.$route.query.fromfreshdesk && !_.isNil(this.$route.query.fromfreshdesk) && this.$route.query.fromfreshdesk === '1') || DOMAINE.indexOf('freshdeskmobile') !== -1 || (this.$route.query.fromfreshdeskmobile && !_.isNil(this.$route.query.fromfreshdeskmobile) && this.$route.query.fromfreshdeskmobile === '1')) { // || DOMAINE.indexOf('localhost') !== -1
      // https://localhost/watcheezy3/#/login?fromfreshdesk=1&token=6f2cb16e813efcaf435883a0a032a890
      this.hidecontent = '1'
      this.connexionType = 'freshdesk'
      this.$vuetify.theme.primary = '#12344d'
      this.$vuetify.theme.secondary = '#d33c4e'
      this.$vuetify.theme.accent = '#3278b2'
      this.$vuetify.theme.tertiary = '#969696'
      // Tests s'il y a bien un identifiant agent dans l'url
      if (this.$route.query.token && !_.isNil(this.$route.query.token) && this.$route.query.token !== '') {
        // console.log('---> il y a un token freshdesk')
        this.token = this.$route.query.token
        this.welcome = 'trafic/chatting'
        // console.log('--> login 2')
        this.login(true)
      } else {
        // console.log('---> pas de token freshdesk')
        this.hidecontent = '0'
      }
    }

    // ----------------------------------------------------------------------------
    // Pour TUNNEL RINGOVER
    // ----------------------------------------------------------------------------
    // Tests afin de savoir s'il s'agit d'une connexion depuis un mail ringover
    if (this.$route.query.sso && !_.isNil(this.$route.query.sso) && this.$route.query.sso === 'ringover') {
      // https://backoffice.targetfirst.com/#/login?sso=ringover&token=f568b6e02e301fd5bce50c4d1e560819&key=4c8a5fed91bb7ebdbe537a97e9982897
      // http://localhost:8889/#/login?sso=ringover&token=f568b6e02e301fd5bce50c4d1e560819&key=4c8a5fed91bb7ebdbe537a97e9982897
      if ((this.$route.query.token && !_.isNil(this.$route.query.token) && this.$route.query.token !== '') && (this.$route.query.key && !_.isNil(this.$route.query.key) && this.$route.query.key !== '')) {
        this.sso = this.$route.query.sso
        this.token = this.$route.query.token
        this.key = this.$route.query.key
        this.login(true)
      }
    }

    // sur quel device est l'utilisateur et si sur ios
    this.setStoreIsMobile(this.isMobile)
    // console.log('isMobileIOS', this.isMobileIOS)
    this.setStoreIsMobileIOS(this.isMobileIOS)

    // si il y a une demande d'ouverture direct de chat au login
    if (this.$route.query.directChat) {
      // console.log('LOGIN :: il y a du directChat', this.$route.query.directChat)
      // this.directChat = this.$route.query.directChat
      sessionStorage.setItem('tf-directChat', this.$route.query.directChat)
    } else {
      // console.log('LOGIN :: pas de directChat')
      sessionStorage.removeItem('tf-directChat')
    }
    // console.log('login created', self.location.href).
    // console.log('login created this.$route.params.id', this.$route.params.id)
    // Redirection si vient de watcheezy.net
    if (window.location.origin.indexOf('public.targetfirst.com') > -1) {
      window.location.href = 'https://adminv2.targetfirst.com'
    }
    if (window.location.origin.indexOf('localhost') > -1) {
      this.email = 'demo@watcheezy.fr'
      this.password = '123456'
    }
    // Tests afin de savoir s'il s'agit d'une création de compte
    if (this.$route.query.welcome && !_.isNil(this.$route.query.welcome)) {
      if (this.$route.query.welcome === 'botbuilder') {
        this.welcome = this.$route.query.welcome
      }
    }
    // Tests afin de savoir s'il s'agit d'une connexion SSO
    if (this.$route.query.sso && !_.isNil(this.$route.query.sso)) {
      if (this.$route.query.sso !== '') {
        this.sso = this.$route.query.sso
      }
    }
    // Tests afin de savoir s'il s'agit d'une erreur SSO
    if (this.$route.query.ErrSso && !_.isNil(this.$route.query.ErrSso)) {
      if (this.$route.query.ErrSso !== '') {
        this.dialogSSO = true
      }
    }
    if ((this.$route.query.email && !_.isNil(this.$route.query.email) &&
      (this.$route.query.password && !_.isNil(this.$route.query.password)))) {
      this.email = this.$route.query.email
      this.password = this.$route.query.password
      // console.log('--> login 3')
      this.login()
    }
    /* else if (this.$route.query.register && !_.isNil(this.$route.query.register)) {
      this.loadingRegister = true
      this.email = this.$route.query.register
      this.axios.get('get/check_register.php?email=' + this.email)
      .then(res => {
        this.registering = true
        this.$gtm.trackView('LoginRegister', 'currentpath')
        this.$gtm.trackEvent({
          event: null, // Event type [default = 'interaction'] (Optional)
          category: 'arrivé page creation de compte',
          action: 'email valider',
          label: this.email + ' est sur la page de creation de compte',
          value: 10,
          noninteraction: false // Optional
        })
      })
      .catch(() => {
        this.email = ''
        window.location = `${DOMAINE}/#/login`
      })
      .then(() => {
        this.loadingRegister = false
      })
    } */
    // Test pour savoir si déjà connecté
    console.log('déjà connetcé , :', this.$store.getters.logged)
    if (this.$store.getters.logged) {
      // this.$store.dispatch('_StoreWatcheeBox/ACTION_RELOAD_LOGIN') // vuex action
    //   // this.$store.dispatch('logout')
    //   console.log('[Login] logout ')
    //   this.$store.dispatch('_StoreWatcheeBox/removeAllChatsSession', this.$socket) // vuex action
    }
  },

  mounted () {
    // Choisir un élément aléatoirement au montage du composant
    const index = Math.floor(Math.random() * this.elements.length)
    this.randomElement = this.elements[index]

    if (this.$store.state.reasonDeco) {
      this.dialogDeconnexion = true
    }
    this.settingsFromCookies()
    // check si localstorage login existe
    if (localStorage.getItem('tf-login') === null) {
      this.rememberPwd = false
    } else {
      this.rememberPwd = true
      // console.log('--> login 4')
      this.login(true)
    }
  },

  methods: {
    ...mapMutations(['SET_REASON_DECO']),
    ...mapMutations('_User', [
      'SET_ISMOBILE',
      'SET_ISMOBILEIOS'
    ]),
    // enregistre le device de l'utilisateur
    setStoreIsMobile (data) {
      // console.log('setStoreIsMobile ==>', data)
      this.SET_ISMOBILE(data)
    },
    // l'utilisateur est il sur ios
    setStoreIsMobileIOS (data) {
      this.SET_ISMOBILEIOS(data)
    },

    closeDialogDeco () {
      this.dialogDeconnexion = false
      this.SET_REASON_DECO(null)
    },

    settingsFromCookies () {
      this.settingsConnectStatusCookies = this.$cookie.get('wz-connecting-start') === 'true' || false
    },

    utf8_to_b64 (str) {
      return window.btoa(unescape(encodeURIComponent(str)))
    },

    login (auto) {
      console.log('----> login :: ', this.connexionType)
      if (!this.wzErrors.any()) {
        // memorise le login et password en local storage
        let encodeLogin = this.email
        let encodePass = this.password
        // si connexion auto car mot de passe memorisé
        if (auto) {
          // console.log('--> login :: auto')
          // si deja
          if (localStorage.getItem('tf-login')) {
            encodeLogin = localStorage.getItem('tf-login')
            encodePass = localStorage.getItem('tf-password')
          }
        } else {
          // console.log('--> login :: login/password')
          encodeLogin = this.utf8_to_b64(this.email)
          encodePass = this.utf8_to_b64(this.password)
          // si la case memorisation mot de passe est covhé
          if (this.rememberPwd) {
            // Remember login
            localStorage.setItem('tf-login', encodeLogin)
            // Remember password
            localStorage.setItem('tf-password', encodePass)
          }
        }

        // console.log('get/login.php?email=' + encodeLogin + '&password=' + encodePass + '&sso=' + this.sso + '&token=' + this.token + '&key=' + this.key + '&from=' + this.connexionType)
        this.loadingLogin = true
        this.axios.get('get/login.php?email=' + encodeLogin + '&password=' + encodePass + '&sso=' + this.sso + '&token=' + this.token + '&key=' + this.key + '&from=' + this.connexionType)
        .then(response => {
          // console.log('login response 2', response)
          const data = response.data
          const session = data.session
          // console.log('data session', data.session)
          if (data.redirect) {
            window.location.href = data.redirect
          }
          this.user.id = session.user_id
          this.user.fname = session.user_firstname
          this.user.lname = session.user_lastname
          this.user.mail = session.user_mail
          this.user.mailContact = session.user_emailcontact
          this.user.job = session.user_job
          this.user.phone = session.user_tel
          this.user.ios = Number(session.user_tel_ios)
          this.user.title = session.user_title
          this.user.connectingOnline = (this.connexionType === 'freshdesk' || this.connexionType === 'freshdesk') ? true : this.settingsConnectStatusCookies // pour freshdesk obligatoirement online
          this.user.key = session.key
          this.user.canBeUnavailable = session.user_can_be_unavailable === '1'
          this.user.rights = session.user_rights
          this.user.chatsMax = session.user_nb_chat_max
          this.user.chatNotif = session.user_chat_notif_onoff
          this.user.priority = session.user_priority
          this.user.keywords = session.user_keywords
          this.user.multiSite = session.user_multisite
          this.user.eezylead = session.eezylead_specialtable
          this.user.licAllKeys = session.user_licAllKeys
          this.user.licenceId = session.licence_id
          this.user.licLang = session.lic_lang
          this.user.callbackOnOff = session.callbackOnOff
          this.user.licSpecialtable = session.lic_specialtable
          this.user.licEezyLead = session.lic_eezy_lead
          this.user.chatOnOff = session.chatOnOff
          this.user.usr_is_bot = session.usr_is_bot
          this.user.usr_time_transfert = session.usr_time_transfert
          this.user.usr_bo_notif = session.usr_bo_notif

          // referent de facturation
          this.user.entRefFacturation = session.ent_ref_facturation
          // expiration CB
          this.user.cbExpiration = session.ent_cb_expiration

          // entreprise
          this.user.entKey = session.ent_key
          this.user.entId = session.ent_id
          this.user.entName = session.ent_name
          this.user.entDateCreation = session.ent_datecreation
          this.user.entEezySubscription = session.ent_eezysubscription
          this.user.entEezyExpiry = session.ent_eezyexpiry
          this.user.entLevel = session.ent_level
          this.user.entNbPageTotal = _.toInteger(session.ent_nbpagetotal)
          this.user.entNbPageThisMonth = session.ent_nbpagethismonth
          this.user.entNbPageMax = session.ent_nbpagemax
          this.user.entNbChatThisMonth = session.ent_nbchatthismonth
          this.user.entNbChatMax = session.ent_nbchatmax
          this.user.entBusiness = session.ent_business
          this.user.entOptionPage = session.ent_optionpage
          this.user.entNbAgent = session.ent_nbagent
          this.user.entNbSite = session.ent_nbsite
          this.user.entOptionRecall = session.ent_optionrecall
          this.user.entOptionScreensharing = session.ent_optionscreensharing
          this.user.entBeta = session.ent_beta === '1'
          this.user.facebookToken = session.facebook_token
          this.user.facebookPage = session.facebook_page
          this.user.whatsappTel = session.user_whatsapp_tel
          this.user.whatsappSid = session.user_whatsapp_sid
          this.user.whatsappToken = session.user_whatsapp_token
          this.user.serviceSid = session.user_service_sid
          this.user.configured = session.ent_configured
          this.user.ringover_team_id = session.ent_ringover_team_id

          // url de la conference apizee
          this.user.urlConf = session.usr_url_conf

          this.user.entSF = session.ent_sf
          this.user.entSFUsr = session.ent_sf_usr
          this.user.entSFPwd = session.ent_sf_pwd
          this.user.entSFToken = session.ent_sf_token

          this.user.entSY = session.ent_sy_onoff
          this.user.entSYCToken = session.ent_sy_ctoken
          this.user.entSYCSecret = session.ent_sy_csecret
          this.user.entSYAToken = session.ent_sy_atoken
          this.user.entSYSecret = session.ent_sy_asecret
          this.user.entSYV2 = session.ent_sy_tokenv2
          this.user.entSYCustom = session.ent_sy_customid

          this.user.entZD = session.ent_zd
          this.user.entZDUsr = session.ent_zd_usr
          this.user.entZDDomain = session.ent_zd_domain
          this.user.entZDToken = session.ent_zd_token

          this.user.apz = session.ent_apz
          this.user.apzKey = session.ent_apz_key
          this.user.whatsapp = session.ent_whatsapp
          // url webhook
          // console.log('session.ent_webhook', session.ent_webhook)
          this.user.webhook = (session.ent_webhook && session.ent_webhook !== '') ? JSON.parse(session.ent_webhook) : 0
          // this.user.webhook = ''
          this.user.entOptionPush = session.ent_optionpush
          this.user.entGA = session.ent_ga
          this.user.entGAUsr = session.ent_ga_usr
          this.user.entSlack = session.ent_slack
          this.user.entSlackUsr = session.ent_slack_usr
          this.user.maxVisitors = _.toInteger(session.ent_max_visitors)
          this.user.hideTabVisitors = session.ent_hide_tab_visitors
          this.user.surcisLicience = session.ent_surcis_licence
          this.user.smsOn = session.smsOn
          this.user.consoLastDays = session.consoLastDays
          this.user.installProgress = session.installProgress
          this.user.remainingSteps = session.remainingSteps
          this.user.ongoingTuto = false
          this.user.tutoQuited = false
          if (this.welcome !== '') {
            this.user.tutoQuited = true
          }
          this.user.connexionType = this.connexionType
          this.user.botSelected = []
          this.user.sessionVisioconf = {}

          // temps de travail pour la journée
          this.user.tempsTravail = session.user_time_day
          this.user.jourHebdoTravail = session.user_day_hebdo

          this.user.welcome = this.welcome

          // BRIDES UTILISATEUR
          if (session.user_brides) {
            // si le chat max est bridé à 1, si bride COMPTE_CONSEILLERS_CHAT_MAX est à 0
            if (!session.user_rights_compte_conseillers_chat_max) {
              this.user.chatsMax = 1
            }
            this.user.brides = [
              {'brideName': 'trafic', 'status': session.user_rights_trafic},
              {'brideName': 'trafic_visiteurs', 'status': session.user_rights_trafic_visiteurs},
              {'brideName': 'trafic_attente', 'status': session.user_rights_trafic_attente},
              {'brideName': 'trafic_discussions', 'status': session.user_rights_trafic_discussions},
              {'brideName': 'trafic_monitoring', 'status': session.user_rights_trafic_monitoring},
              {'brideName': 'trafic_monitoring_chat_superviseur', 'status': session.user_rights_trafic_monitoring_chat_superviseur},
              {'brideName': 'stats', 'status': session.user_rights_stats},
              {'brideName': 'stats_audience', 'status': session.user_rights_stats_audience},
              {'brideName': 'stats_conversations', 'status': session.user_rights_stats_conversations},
              {'brideName': 'stats_chatbot', 'status': session.user_rights_stats_chatbot},
              {'brideName': 'stats_chatbot_ai', 'status': session.user_rights_stats_chatbot_ai},
              {'brideName': 'stats_chatbot_histo', 'status': session.user_rights_stats_chatbot_histo},
              {'brideName': 'stats_conseillers', 'status': session.user_rights_stats_conseillers},
              {'brideName': 'stats_callback', 'status': session.user_rights_stats_callback},
              {'brideName': 'stats_visio', 'status': session.user_rights_stats_visio},
              {'brideName': 'stats_ventes', 'status': session.user_rights_stats_ventes},
              {'brideName': 'stats_ventes_chatbot', 'status': session.user_rights_stats_ventes_chatbot},
              {'brideName': 'stats_ventes_callback', 'status': session.user_rights_stats_ventes_callback},
              {'brideName': 'stats_ventes_lead', 'status': session.user_rights_stats_ventes_lead},
              {'brideName': 'stats_leads', 'status': session.user_rights_stats_leads},
              {'brideName': 'stats_leads_getquanty', 'status': session.user_rights_stats_leads_getquanty},
              {'brideName': 'stats_leads_chaleur', 'status': session.user_rights_stats_leads_chaleur},
              {'brideName': 'stats_satisfaction', 'status': session.user_rights_stats_satisfaction},
              {'brideName': 'stats_rapports', 'status': session.user_rights_stats_rapports},
              {'brideName': 'compte', 'status': session.user_rights_compte},
              {'brideName': 'compte_conseillers', 'status': session.user_rights_compte_conseillers},
              {'brideName': 'compte_conseillers_chat_max', 'status': session.user_rights_compte_conseillers_chat_max},
              {'brideName': 'compte_conseillers_transfert', 'status': session.user_rights_compte_conseillers_transfert_auto},
              {'brideName': 'compte_conseillers_prioritaire', 'status': session.user_rights_compte_conseillers_prioritaire},
              {'brideName': 'compte_conseillers_api', 'status': session.user_rights_compte_conseillers_api},
              {'brideName': 'compte_conseillers_black_list', 'status': session.user_rights_compte_conseillers_black_list},
              {'brideName': 'compte_conseillers_indispo', 'status': session.user_rights_compte_conseillers_indispo},
              {'brideName': 'compte_conseillers_notifbo', 'status': session.user_rights_compte_conseillers_notifbo},
              {'brideName': 'compte_sites', 'status': session.user_rights_compte_sites},
              {'brideName': 'compte_attribution', 'status': session.user_rights_compte_attribution},
              {'brideName': 'ciblage', 'status': session.user_rights_ciblage},
              {'brideName': 'media', 'status': session.user_rights_media},
              {'brideName': 'media_phrases', 'status': session.user_rights_media_phrases},
              {'brideName': 'media_phrases_completion', 'status': session.user_rights_media_phrases_completion},
              {'brideName': 'media_push', 'status': session.user_rights_media_push},
              {'brideName': 'media_faq', 'status': session.user_rights_media_faq},
              {'brideName': 'parametre', 'status': session.user_rights_parametre},
              {'brideName': 'parametre_apercu', 'status': session.user_rights_parametre_apercu},
              {'brideName': 'parametre_apercu_couleurs', 'status': session.user_rights_parametre_apercu_couleurs},
              {'brideName': 'parametre_apercu_dimensions', 'status': session.user_rights_parametre_apercu_dimensions},
              {'brideName': 'parametre_apercu_coins', 'status': session.user_rights_parametre_apercu_coins},
              {'brideName': 'parametre_apercu_position', 'status': session.user_rights_parametre_apercu_position},
              {'brideName': 'parametre_apercu_mobile_position', 'status': session.user_rights_parametre_apercu_mobile_position},
              {'brideName': 'parametre_apercu_desk', 'status': session.user_rights_parametre_apercu_desk},
              {'brideName': 'parametre_apercu_mobile_desk', 'status': session.user_rights_parametre_apercu_mobile_desk},
              {'brideName': 'parametre_apercu_sideon', 'status': session.user_rights_parametre_apercu_sideon},
              {'brideName': 'parametre_apercu_hide_moyen', 'status': session.user_rights_parametre_apercu_hide_moyen},
              {'brideName': 'parametre_apercu_conseiller', 'status': session.user_rights_parametre_apercu_conseiller},
              {'brideName': 'parametre_apercu_bot', 'status': session.user_rights_parametre_apercu_bot},
              {'brideName': 'parametre_apercu_hide_liste', 'status': session.user_rights_parametre_apercu_hide_liste},
              {'brideName': 'parametre_apercu_geoloc', 'status': session.user_rights_parametre_apercu_geoloc},
              {'brideName': 'parametre_apercu_lang', 'status': session.user_rights_parametre_apercu_lang},
              {'brideName': 'parametre_apercu_title_close', 'status': session.user_rights_parametre_apercu_title_close},
              {'brideName': 'parametre_apercu_title_offline', 'status': session.user_rights_parametre_apercu_title_offline},
              {'brideName': 'parametre_apercu_title_online', 'status': session.user_rights_parametre_apercu_title_online},
              {'brideName': 'parametre_apercu_message1', 'status': session.user_rights_parametre_apercu_message1},
              {'brideName': 'parametre_apercu_message2', 'status': session.user_rights_parametre_apercu_message2},
              {'brideName': 'parametre_affichage', 'status': session.user_rights_parametre_affichage},
              {'brideName': 'parametre_affichage_perso', 'status': session.user_rights_parametre_affichage_perso},
              {'brideName': 'parametre_affichage_perso_cible', 'status': session.user_rights_parametre_affichage_perso_cible},
              {'brideName': 'parametre_affichage_horaire', 'status': session.user_rights_parametre_affichage_horaire},
              {'brideName': 'parametre_affichage_url', 'status': session.user_rights_parametre_affichage_url},
              {'brideName': 'parametre_chat', 'status': session.user_rights_parametre_chat},
              {'brideName': 'parametre_chat_invitation', 'status': session.user_rights_parametre_chat_invitation},
              {'brideName': 'parametre_chat_formprechat', 'status': session.user_rights_parametre_chat_formprechat},
              {'brideName': 'parametre_chat_premiermessage', 'status': session.user_rights_parametre_chat_premiermessage},
              {'brideName': 'parametre_chat_reponseauto', 'status': session.user_rights_parametre_chat_reponseauto},
              {'brideName': 'parametre_chat_editlead', 'status': session.user_rights_parametre_chat_editlead},
              {'brideName': 'parametre_chat_istyping', 'status': session.user_rights_parametre_chat_istyping},
              {'brideName': 'parametre_chat_iframe', 'status': session.user_rights_parametre_chat_iframe},
              {'brideName': 'parametre_callback', 'status': session.user_rights_parametre_callback},
              {'brideName': 'parametre_bot', 'status': session.user_rights_parametre_bot},
              {'brideName': 'parametre_cobrowsing', 'status': session.user_rights_parametre_cobrowsing},
              {'brideName': 'parametre_cobrowsing_cobrowsing', 'status': session.user_rights_parametre_cobrowsing_cobrowsing},
              {'brideName': 'parametre_cobrowsing_mirroring', 'status': session.user_rights_parametre_cobrowsing_mirroring},
              {'brideName': 'parametre_cobrowsing_screensharing_apz', 'status': session.user_rights_parametre_cobrowsing_screensharing_apz},
              {'brideName': 'parametre_ecommerce', 'status': session.user_rights_parametre_ecommerce},
              {'brideName': 'parametre_connecteur', 'status': session.user_rights_parametre_connecteur},
              {'brideName': 'parametre_connecteur_facebook', 'status': session.user_rights_parametre_connecteur_facebook},
              {'brideName': 'parametre_connecteur_messenger', 'status': session.user_rights_parametre_connecteur_messenger},
              {'brideName': 'parametre_connecteur_salseforce', 'status': session.user_rights_parametre_connecteur_salseforce},
              {'brideName': 'parametre_connecteur_zendesk', 'status': session.user_rights_parametre_connecteur_zendesk},
              {'brideName': 'parametre_connecteur_freshdesk', 'status': session.user_rights_parametre_connecteur_freshdesk},
              {'brideName': 'parametre_connecteur_analytics', 'status': session.user_rights_parametre_connecteur_analytics},
              {'brideName': 'parametre_connecteur_slack', 'status': session.user_rights_parametre_connecteur_slack},
              {'brideName': 'parametre_connecteur_vyte', 'status': session.user_rights_parametre_connecteur_vyte},
              {'brideName': 'parametre_connecteur_calendar', 'status': session.user_rights_parametre_connecteur_calendar},
              {'brideName': 'parametre_connecteur_apz', 'status': session.user_rights_parametre_connecteur_apz},
              {'brideName': 'parametre_connecteur_whatsapp', 'status': session.user_rights_parametre_connecteur_whatsapp},
              {'brideName': 'parametre_push', 'status': session.user_rights_parametre_push},
              {'brideName': 'parametre_push_auto', 'status': session.user_rights_parametre_push_auto},
              {'brideName': 'parametre_analytics', 'status': session.user_rights_parametre_analytics},
              {'brideName': 'parametre_recall', 'status': session.user_rights_parametre_recall},
              {'brideName': 'parametre_webcall', 'status': session.user_rights_parametre_webcall},
              {'brideName': 'parametre_visio', 'status': session.user_rights_parametre_visio},
              {'brideName': 'parametre_planning', 'status': session.user_rights_parametre_planning},
              {'brideName': 'parametre_sms', 'status': session.user_rights_parametre_sms},
              {'brideName': 'parametre_absence', 'status': session.user_rights_parametre_absence},
              {'brideName': 'parametre_messaging', 'status': session.user_rights_parametre_messaging},
              {'brideName': 'multisite_indicateur', 'status': session.user_rights_multisite_indicateur},
              {'brideName': 'mindmap_edition', 'status': session.user_rights_bot_mindmap_edition},
              {'brideName': 'parametre_product', 'status': session.user_rights_parametre_product},
              {'brideName': 'ticketing', 'status': session.user_rights_parametre_ticketing},
              {'brideName': 'proposed_ai', 'status': session.user_rights_chat_proposed_ai},
              {'brideName': 'parametre_chatbot', 'status': session.user_rights_parametre_chatbot},
              {'brideName': 'parametre_chatbot_advanced', 'status': session.user_rights_parametre_chatbot_advanced},
              {'brideName': 'parametre_chatbot_watson', 'status': session.user_rights_parametre_chatbot_watson}
            ]
          }
          this.user.deskAutochat = session.desk_autochat
          this.user.askGeoloc = session.desk_ask_geoloc
          this.user.connectFromAdmin = session.connectFromAdmin
          this.user.colleagues = session.user_colleagues
          this.user.user_sites = session.user_sites
          this.user.bots = session.user_bots
          this.user.filterFront = session.ent_filter_front
          // la langue du backoffice sera celle choisie dans le select
          this.user.lang = this.$i18n.locale
          this.$cookie.set('wz-lang', this.$i18n.locale, { expires: '1Y' })
          // avatar
          this.user.avatar = null
          let avatar = session.avatarfilename
          if (avatar !== 'unknown.gif' && !_.isNil(avatar) && avatar !== '') {
            this.user.avatar = avatar
          }
          // EXCEPTIONS CLIENTS
          // KAUFMAN KetB
          this.user.ketb = 0
          if (session.ent_id === '4683') {
            this.user.ketb = 1
          }

          this.$store.dispatch('loginUser', this.user)
          // efface le cookie de memo des dialogbox d'alert quota
          this.$cookie.set('memoDialogQuota', '0', { expires: '10h' })
          this.$cookie.set('memoDialogC2C', '0', { expires: '10h' })
          this.$cookie.set('memoDialogExpireCB', '0', { expires: '10h' })
          this.$cookie.set('ringover_team_id', this.user.ringover_team_id, { expires: '72h' })
        })
        .catch(resp => {
          this.loadingLogin = false
          console.log('login.vue response :', resp)
          // if (resp.response.status === 401) {
          //   this.snack.msg = 'Account disabled'
          // } else {
          //   this.snack.msg = this.$t('emailPassNotMatch')
          // }
          this.snack.context = 'error'
          this.snack.show = true
        })
      } else {
        this.snack.msg = this.$t('notFilled')
        this.snack.context = 'error'
        this.snack.show = true
      }
    },
    /**
     * Met à jour la langue du backoffice
     * @param {string} newLang : nouvelle langue choisie
     */
    updateLang (newLang) {
      this.$i18n.locale = newLang
    },
    register () {
      this.$validator.validateAll()
      if (this.wzErrors.any()) {
        this.snack.msg = this.$t('notFilled')
        this.snack.context = 'error'
        this.snack.show = true
        return
      }
      // Création de la licence
      let dataToPost = new window.FormData()
      dataToPost.append('url', this.url)
      dataToPost.append('email', this.email)
      dataToPost.append('password', this.password)
      dataToPost.append('firstName', this.firstName)
      dataToPost.append('lastName', this.lastName)
      dataToPost.append('phone', this.phone)
      this.loadingLogin = true
      this.axios.post('post/register.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.wzkey = response.data
        this.dialog = true
        this.trackEvent()
        // NICE TO HAVE
        // envoi par mail de la ligne de script
        //  à un technicien
      })
      .catch(() => {
        this.snack.msg = this.$t('error')
        this.snack.context = 'error'
        this.snack.show = true
      })
      .then(() => {
        this.loadingLogin = false
      })
    },
    retrieve () {
      // Création de la licence
      let dataToPost = new window.FormData()
      dataToPost.append('email', this.email)
      dataToPost.append('lang', this.$i18n.locale)
      this.loadingLogin = true
      this.axios.post('post/pwd_retrieve.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.dialogRetrieve = false
      })
      .catch(() => {
        this.snack.msg = this.$t('error')
        this.snack.context = 'error'
        this.snack.show = true
      })
      .then(() => {
        this.loadingLogin = false
      })
    },
    trackEvent () {
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'register OK',
        action: 'Validation',
        label: 'finalisation inscription essai',
        value: 5000,
        noninteraction: false // Optional
      })
    }
  },
  watch: {
    settingsConnectStatusCookies (v) {
      this.$cookie.set('wz-connecting-start', v, { expires: '1Y' })
    }
    // rememberPwd (v) {
    //   console.log('v', v)
    //   // si decoché on efface le login et password du localstorage
    //   if (!v) {
    //     localStorage.removeItem('tf-login')
    //     localStorage.removeItem('tf-password')
    //   }
    // }
  }
}

function loadGoogle () {
  var tf = document.createElement('script')
  tf.type = 'text/javascript'
  tf.async = true
  tf.src = document.location.protocol + '//accounts.google.com/gsi/client'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(tf, s)
}

loadGoogle()

</script>

<style >
 .v-input__control>.v-input__slot {
    border-radius: 8px !important;
  }
  .Marge {
    padding-left: 10%;
    padding-right: 10%;
  }
  
  .v-input__control>.v-input__slot::before,
  .v-input__control>.v-input__slot::after {
    border: 0px solid !important;
  }
  .v-btn {
    font-size: 16px;
    text-transform: none !important;
  }
  input:focus {
    outline: none;
    box-shadow: none;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #f0f0f0 inset !important;
    box-shadow: 0 0 0 1000px #f0f0f0 inset !important;
    -webkit-text-fill-color: #000 !important;
  }
  input {
    outline: none;
    box-shadow: none;
    background-color: transparent;
    border-style: none;
    color: inherit;
  }
  .theme--light.v-text-field--box>.v-input__control>.v-input__slot,
  .theme--light.v-text-field--box>.v-input__control>.v-input__slot:hover {
    background-color: #f0f0f0 !important;
  }
</style>

<style scoped>
  div#app {
      height: 100%;
  }
  /* image de fond */
  .login {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
  }
  .v-input__control>.v-input__slot {
    border-radius: 8px !important;
  }

  
  .connectLinkedin a:link, .connectLinkedin a:visited, .connectLinkedin a:hover, a:active
  {
  	color: #000000;
  	text-decoration: none;
  }
  .connectwith{
  	margin-left:5px;
  	flex-grow: 1;
  	font-weight: 500;
  	font-family: "Google Sans",arial,sans-serif;
  	color: #3c4043;
  	cursor: pointer;
  	font-size: 14px;
  	height: 40px;
  	letter-spacing: 0.25px;
  	outline: none;
  	overflow: hidden;
  	text-align: center;
  	vertical-align: super;
  	white-space: nowrap;
  }
  .loginButton{
  	border-radius: 5px;
  	display: inline-block;
  	border: 1px solid #dbdbdb;
  	padding: 7px;
  	color: #3c4043;
    width: 239px
  }
  .centerLogin {
    display: flex;
    flex-direction: column-reverse;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue